import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import DOMPurify from "dompurify";

export function isJSON(input: string) {
  try {
    const parsed = JSON.parse(input);
    return typeof parsed === "object";
  } catch {
    return false;
  }
}

export function htmlToJSON(html: string) {
  const safeHTML = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });

  const editor = new Editor({
    extensions: [StarterKit],
    content: safeHTML,
  });

  const json = editor.getJSON();
  editor.destroy();

  return json;
}

export function jsonToHTML(json: any) {
  const editor = new Editor({
    extensions: [StarterKit],
    content: json,
  });

  const html = editor.getHTML();
  editor.destroy();

  return html;
}